module.exports = __webpack_public_path__ + "static/bg-wedding2-7bdc22a7e10bc5fbaf12ce8e7895a563.jpeg";